import React from "react";

export default function AssignProduct() {
  return (
    <div className="p-6">
      <div className="text-base font-medium group-[.mode--light]:text-white">Assign Products</div>
      <div className="mt-2 text-slate-600 dark:text-slate-400">
        Coming soon. We’ll port the APSales Assign Products page once the StockLedger backend tables/endpoints exist.
      </div>
    </div>
  );
}

